import styled from "styled-components";

export const PricingSwitchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
`;

export const PricingPicker = styled.div`
  width: 114px;
  height: 33px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-shadow: ${(props) =>
    props.switchValue === props.switch
      ? "0px 4px 4px 0px rgba(0, 0, 0, 0.1)"
      : "none"};
  background: ${(props) =>
    props.switchValue === props.switch
      ? props.theme.colors.green
      : props.theme.colors.white};
`;

export const PricingText = styled.p`
  margin: 0;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  color: ${(props) =>
    props.switchValue === props.switch
      ? props.theme.colors.white
      : props.theme.colors.gray90};
`;

export const SubTitle = styled.p`
  margin: 0;
  text-align: center;
  font-size: 10px;
  font-weight: 400;
  color: ${(props) =>
    props.switchValue === props.switch
      ? props.theme.colors.white
      : props.theme.colors.gray90};
`;
